module.exports = __webpack_public_path__ + "static/media/logo.de8bf740.png";